import { render, staticRenderFns } from "./NewCart.vue?vue&type=template&id=a0a7f1d4&"
import script from "./NewCart.vue?vue&type=script&lang=ts&"
export * from "./NewCart.vue?vue&type=script&lang=ts&"
import style0 from "./NewCart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports